// @flow

import { toastr } from 'react-redux-toastr';
import { makeApiCall } from '../../../../services/apiService/apiService';
import { toKeyValPair } from '../../../../services/helpers';

export const vasChargesActions = {
  GET_DASHBOARD_DATA: 'GET_DASHBOARD_DATA',
  UPDATE_PAGE_NUMBER: 'UPDATE_PAGE_NUMBER',
  UPDATE_FILTER: 'UPDATE_FILTER',
  TOGGLE_ADDRESS_SELECT: 'TOGGLE_ADDRESS_SELECT',
  TOGGLE_CNOTE_SELECT: 'TOGGLE_CNOTE_SELECT',
  RESET_FORM: 'RESET_FORM',
  UPDATE_FORM: 'UPDATE_FORM'
};

export const getDashboardDataAction = payload => ({
  type: vasChargesActions.GET_DASHBOARD_DATA,
  payload
});

export const updatePageNumber = payload => ({
  type: vasChargesActions.UPDATE_PAGE_NUMBER,
  payload
});

export const updateFilter = (key, payload) => ({
  type: vasChargesActions.UPDATE_FILTER,
  key,
  payload
});

export const toggleAddressSelect = (key, chargeType, vasChargeType) => (
  dispatch: Function,
  getState
) => {
  const { vasChargesState } = getState();
  const { addresses } = vasChargesState;
  const addressList = [];

  (addresses || []).forEach((address, index) => {
    if (index === key) {
      if (chargeType === vasChargeType.DEDICATED) {
        addressList[index] = { ...address, selected: !address.selected };
      } else {
        addressList[index] = { ...address, selected: true };
      }
    } else {
      if (chargeType === vasChargeType.DEDICATED) {
        addressList[index] = { ...address };
      } else {
        addressList[index] = { ...address, selected: false };
      }
    }
  });
  dispatch({
    type: vasChargesActions.TOGGLE_ADDRESS_SELECT,
    payload: addressList
  });
};

export const toggleCnoteSelect = (address, addressIndex, cnote, cnoteIndex) => {
  const updatedCnote = Object.assign(cnote, { selected: !cnote.selected });
  address.cnoteList[cnoteIndex] = Object.assign(
    address.cnoteList[cnoteIndex],
    updatedCnote
  );

  return {
    type: vasChargesActions.TOGGLE_CNOTE_SELECT,
    key: addressIndex,
    payload: address
  };
};

export const resetForm = () => {
  return {
    type: vasChargesActions.RESET_FORM,
    payload: {
      addresses: [],
      vehicleNumber: null,
      vehicleType: null,
      totalCharge: null,
      receiptUrl: null,
      emailEvidenceUrl: null
    }
  };
};
export const updateForm = rowData => (dispatch: Function) => {
  const { addressDTOList, chargeLocationIds, applicableCnotes } = rowData;
  const addressList = [];
  const addressDTOListCopy = JSON.parse(JSON.stringify(addressDTOList));

  (addressDTOListCopy || []).forEach((address, index) => {
    addressList[index] = {
      ...address,
      selected: chargeLocationIds.indexOf(address.addressId) >= 0
    };

    (address.cnoteList || []).forEach((cnote, cnoteIndex) => {
      const updatedCnote = {
        key: cnote,
        value: cnote,
        selected: applicableCnotes.indexOf(cnote) >= 0
      };
      addressList[index].cnoteList[cnoteIndex] = updatedCnote;
    });

    dispatch({
      type: vasChargesActions.UPDATE_FORM,
      payload: {
        addresses: addressList,
        totalCharge: rowData.totalAmount,
        receiptUrl: rowData.receiptUrl,
        emailEvidenceUrl: rowData.emailEvidenceUrl || null,
        vehicleType: rowData.vehicleType,
        vehicleNumber: rowData.vehicleNumber
      }
    });
  });
};

export const getDashboardData = (obj: Object) => (
  dispatch: Function,
  getState
) => {
  const { vasChargesState } = getState();
  const defaultVal = {
    isLoading: false,
    isLoaded: true,
    dashBoardData: [],
    totalElements: 0
  };
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'vasChargesGetDashboard',
    method: 'GET',
    replaceParamsArr: [
      { key: 'chargeType', val: obj.chargeType },
      {
        key: 'startDate',
        val: obj.startDate
      },
      {
        key: 'endDate',
        val: obj.endDate
      },
      { key: 'search', val: vasChargesState.filters.searchString },
      { key: 'pageNumber', val: vasChargesState.pageNumber },
      { key: 'pageSize', val: vasChargesState.pageSize }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            dashBoardData: res.payload,
            totalElements: res.totalElements
          })
        );
      } else {
        dispatch(getDashboardDataAction(defaultVal));
      }
    },
    failureCb: res => {
      dispatch(getDashboardDataAction(defaultVal));
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get VAS'
      );
    },
    catchCb: res => {
      dispatch(getDashboardDataAction(defaultVal));
      toastr.error('Something went wrong!', 'Could not get VAS');
    }
  };

  return makeApiCall(requestObj);
};

const modifyAddressListForSelectAndUnselect = (
  addressList: Object,
  chargeType: String,
  vasChargeType: Object
) => {
  let addressListFormatted = (addressList || []).map((address, index) => {
    let cnoteList = toKeyValPair(address.cnoteList || [], 'selected', true);
    if (chargeType === vasChargeType.DEDICATED) {
      return { ...address, selected: true, cnoteList };
    } else {
      return {
        ...address,
        selected: index === 0 ? true : false,
        cnoteList
      };
    }
  });
  return addressListFormatted;
};

export const fetchAddresses = (obj: Object) => (dispatch: Function) => {
  const defaultVal = {
    isLoading: false,
    isLoaded: true,
    addresses: [],
    vehicleNumber: null,
    vehicleType: null
  };

  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'vasUnionDetails',
    method: 'GET',
    replaceParamsArr: [
      { key: 'entityType', val: obj.entityType },
      { key: 'entityId', val: obj.entityId },
      { key: 'locationType', val: obj.locationType },
      { key: 'activityType', val: obj.activityType }
    ],
    successCb: res => {
      if (
        res.status === 'SUCCESS' &&
        res.payload &&
        res.payload.addressDTOList &&
        res.payload.addressDTOList.length
      ) {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            addresses:
              modifyAddressListForSelectAndUnselect(
                res.payload.addressDTOList,
                obj.chargeType,
                obj.vasChargeType
              ) || [],
            vehicleNumber: res.payload.vehicleNumber || null,
            vehicleType: res.payload.vehicleType || null
          })
        );
      } else {
        dispatch(getDashboardDataAction(defaultVal));
      }
    },
    failureCb: res => {
      dispatch(getDashboardDataAction(defaultVal));
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get tasks'
      );
    },
    catchCb: res => {
      dispatch(getDashboardDataAction(defaultVal));
      toastr.error('Something went wrong!', 'Could not get tasks');
    }
  };

  return makeApiCall(requestObj);
};

export const getVehicleTypes = (obj: Object) => (
  dispatch: Function,
  getState
) => {
  const { vasChargesState } = getState();
  const { vehicleTypesOptions } = vasChargesState;
  const defaultVal = {
    isLoading: false,
    isLoaded: true,
    vehicleTypesOptions: null
  };
  if (vehicleTypesOptions) {
    return;
  }
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getVehicleTypes',
    method: 'GET',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            vehicleTypesOptions: toKeyValPair(res.payload || []) || []
          })
        );
      } else {
        dispatch(getDashboardDataAction(defaultVal));
      }
    },
    failureCb: res => {
      dispatch(getDashboardDataAction(defaultVal));
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get vehicle type'
      );
    },
    catchCb: res => {
      dispatch(getDashboardDataAction(defaultVal));
      toastr.error('Something went wrong!', 'Could not get vehicle type');
    }
  };

  return makeApiCall(requestObj);
};

export const fetchTotalCharge = (obj: Object) => (dispatch: Function) => {
  const defaultVal = {
    isLoading: false,
    isLoaded: true,
    totalCharge: null
  };
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false
    })
  );
  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'getTotalVasCharge',
    method: 'GET',
    replaceParamsArr: [
      { key: 'vasChargeType', val: obj.vasChargeType },
      { key: 'chargeBasis', val: obj.chargeBasis },
      { key: 'charge', val: obj.charge },
      { key: 'cnoteList', val: obj.cnoteList }
    ],
    successCb: res => {
      if (res.status === 'SUCCESS' && res.payload) {
        dispatch(
          getDashboardDataAction({
            isLoading: false,
            isLoaded: true,
            totalCharge: res.payload
          })
        );
      } else {
        dispatch(getDashboardDataAction(defaultVal));
      }
    },
    failureCb: res => {
      dispatch(getDashboardDataAction(defaultVal));
      toastr.error(
        'Something went wrong!',
        res.errorMessage || 'Could not get total charge'
      );
    },
    catchCb: res => {
      dispatch(getDashboardDataAction(defaultVal));
      toastr.error('Something went wrong!', 'Could not get total charge');
    }
  };

  return makeApiCall(requestObj);
};

export const submitData = (
  obj: Object,
  onPostSuccessfulSubmission: Function
) => (dispatch: Function) => {
  const defaultVal = {
    isLoading: false,
    isLoaded: true
  };
  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false
    })
  );

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: 'postVasData',
    data: obj,
    method: 'POST',
    successCb: res => {
      if (res.status === 'SUCCESS') {
        dispatch(getDashboardDataAction(defaultVal));
        toastr.success(res.payload || 'Data submitted successfully');
        onPostSuccessfulSubmission();
      } else if (res.status === 'FAILURE') {
        dispatch(getDashboardDataAction(defaultVal));
      }
    },
    failureCb: res => {
      toastr.error(res.errorMessage || 'Failed to perform operation');
      dispatch(getDashboardDataAction(defaultVal));
    },
    catchCb: res => {
      toastr.error('Failed to perform operation');
      dispatch(getDashboardDataAction(defaultVal));
    }
  };

  return makeApiCall(requestObj);
};

export const uploadImage = (file, isReceiptFile) => (dispatch: Function) => {
  const dispatchObj = {
    isLoading: false,
    isLoaded: true,
    error: null
  };

  if (!file) {
    if (isReceiptFile) {
      dispatchObj.receiptUrl = null;
    } else {
      dispatchObj.emailEvidenceUrl = null;
    }
    dispatch(getDashboardDataAction(dispatchObj));
    return;
  }

  dispatch(
    getDashboardDataAction({
      isLoading: true,
      isLoaded: false
    })
  );

  let formData = new FormData();

  formData.append(isReceiptFile ? 'receipt' : 'emailEvidence', file, 'file');

  const defaultVal = {
    isLoading: false,
    isLoaded: true
  };

  const requestObj = {
    baseUrl: 'zoomApiUrl',
    apiEndPoint: isReceiptFile ? 'uploadVasReceipt' : 'uploadVasEmail',
    postFormData: true,
    data: formData,
    contentType: undefined,
    method: 'POST',
    successCb: res => {
      if (res.status === 'SUCCESS' && res.payload) {
        if (isReceiptFile) {
          dispatchObj.receiptUrl = res.payload;
        } else {
          dispatchObj.emailEvidenceUrl = res.payload;
        }

        dispatch(getDashboardDataAction(dispatchObj));
        toastr.success('Image uploaded successfully');
      } else if (res.status === 'FAILURE') {
        dispatch(getDashboardDataAction(defaultVal));
      }
    },
    failureCb: res => {
      toastr.error(
        res.errorMessage || 'Failed to upload image.Please try again.'
      );
      dispatch(getDashboardDataAction(defaultVal));
    },
    catchCb: res => {
      toastr.error('Failed to upload image.Please try again.');
      dispatch(getDashboardDataAction(defaultVal));
    }
  };

  return makeApiCall(requestObj);
};
